import * as React from "react";
import { forwardRef } from "react";
const SvgEventCategoryOther = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	clipRule: "evenodd",
	d: "M24.5003 3h-17c-2.4853 0-4.5 2.0147-4.5 4.5v17c0 2.4853 2.0147 4.5 4.5 4.5h17c2.4853 0 4.5-2.0147 4.5-4.5v-17c0-2.4853-2.0147-4.5-4.5-4.5Zm-17-3c-4.1421 0-7.5 3.3579-7.5 7.5v17c0 4.1421 3.3579 7.5 7.5 7.5h17c4.1422 0 7.5-3.3579 7.5-7.5v-17c0-4.1421-3.3578-7.5-7.5-7.5h-17Z",
	fill: "currentColor",
	fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.5003 16c0 1.3807-1.1192 2.5-2.5 2.5-1.3807 0-2.5-1.1193-2.5-2.5s1.1193-2.5 2.5-2.5c1.3808 0 2.5 1.1193 2.5 2.5ZM18.5003 16c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5 1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5ZM26.5003 16c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5 1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgEventCategoryOther);
export default ForwardRef;
